jQuery(document).ready(function($) {
    var targetUrl = myScriptParams.targetUrl; // The variable from your .env file
    const currentUrl = new URL(window.location.href);
    const targetUrlObj = new URL(targetUrl);
    const isMobile = window.matchMedia("(max-width: 649px)").matches;

    if(isMobile){
        jQuery(window).on('load', function() {
            setTimeout(function() {
                $('.slick-track').css({
                    'width': '5000px'
                });
            }, 100); // 2000 milliseconds delay (2 seconds)
        });
    }
    
    

    // Check if the current page's URL matches the target URL
    if (currentUrl.pathname === targetUrlObj.pathname) {
        // הפעלת הקרוסלה של car marker תמיד
        jQuery('.slider_car_marker.site-row').slick({
            infinite: true, // Enables infinite looping
            slidesToShow: isMobile ? 3 : 6,
            speed: 2000,
            slidesToScroll: isMobile ? 3 : 6,
            rtl: true,
            arrows: false,
            dots: false,
            autoplay: true, // Enables autoplay
            autoplaySpeed: 2000, // Time in milliseconds between each slide change
            pauseOnHover: true, // Pauses autoplay when hovering
        });

        // בדיקה אם יש מספיק רכבים עם hot deal לפני הפעלת הקרוסלה
        const hotDealCars = $('.cmp_hotdeal .listing_cars > .content-car .each_part_car');
        if (hotDealCars.length < 3) {
            $('.component_hot_deal').remove();
        } else {
            function extractCarData() {
                const carsContainer = document.querySelector('.cmp_hotdeal .listing_cars > .content-car');
                const cars = carsContainer.querySelectorAll('.each_part_car');
                const carsToEnd = [];
    
                cars.forEach(car => {
                    const imageCarDiv = car.firstElementChild.firstElementChild;
                    const car_image = imageCarDiv.querySelector('img').src;
                    if (car_image.includes('missing')) {
                        carsToEnd.push(car);
                    }
                });

                // Remove the cars with missing images from their current position and append them at the end.
                carsToEnd.forEach(car => {
                    carsContainer.appendChild(car);
                });
            }
    
            extractCarData();
            
            jQuery('.cmp_hotdeal .listing_cars > .content-car').slick({
                infinite: false,
                slidesToShow: isMobile ? 1 : 3,
                speed: isMobile ? 700 : 2000,
                draggable: false,
                slidesToScroll: isMobile ? 1 : 3,
                rtl: true,
                arrows: !isMobile,
                dots: false,
                centerMode: isMobile,
            });
        }
    
        jQuery('.facebook_feed_hmp .efbl_feeds_holder.efbl_feeds_thumbnail').slick({
            infinite: !isMobile,
            slidesToShow: isMobile ? 1 : 3,
            speed: isMobile ? 1000 : 2000,
            draggable: false,
            slidesToScroll: isMobile ? 1 : 3,
            rtl: true,
            arrows: !isMobile,
            dots: false,
            centerMode: !isMobile,
        });
        
        function finalize() {
            const button = $('div.gradient_div');
            const footerDiv = $('footer div.first-section');
    
            $(document).on('scroll', function () {
                const winBottom = window.scrollY + window.innerHeight;
                if (winBottom >= footerDiv.position().top) {
                    button.css('opacity', 0);
                } else {
                    button.css('opacity', 1);
                }
                if(isMobile){
                        setTimeout(function() {
                            $('.slick-track').css({
                                'width': '5000px'
                            });
                        }, 10); // 2000 milliseconds delay (2 seconds)
                }
            });

        }
        finalize();
    }
    
})



// WEBPACK FOOTER //
// ./scripts/routes/home.js